import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { computed, inject, onMounted, ref, watch } from "vue";
import { CartServiceSymbol, FileServiceSymbol, ProductServiceSymbol } from "@/InjectionSymbols";
import ProductMetaContainer from "@/components/ProductMetaContainer.vue";
import { useMessageStore } from "@/stores/MessageStore";
import ProductPreviewComponent from "@/components/ProductPreviewComponent.vue";
import { useRouter } from "vue-router";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductView',
    props: {
        id: {
            type: String,
            required: true
        }
    },
    setup(__props) {
        const cartService = inject(CartServiceSymbol);
        const productService = inject(ProductServiceSymbol);
        const fileService = inject(FileServiceSymbol);
        const messageStore = useMessageStore();
        const router = useRouter();
        const product = ref(null);
        const crossSellProducts = ref([]);
        const props = __props;
        const breadCrumbs = computed(() => {
            if (product.value && typeof router.currentRoute.value.meta.breadCrumb === "function") {
                return router.currentRoute.value.meta.breadCrumb(product.value.title);
            }
            return null;
        });
        let imageUrl = ref(require('@/assets/productPlaceholder.png'));
        onMounted(() => {
            productService?.loadProduct(props.id).then((product) => {
                productLoaded(product);
            });
        });
        watch(() => props.id, (newProductId) => {
            productService?.loadProduct(newProductId).then((product => {
                productLoaded(product);
            }));
        });
        function productLoaded(loadedProduct) {
            product.value = loadedProduct;
            crossSellProducts.value.length = 0;
            product.value.crossSells.forEach(value => productService?.loadProduct(value.toString()).then((crossSellProduct) => crossSellProducts.value.push(crossSellProduct)));
            loadImage(loadedProduct);
        }
        function click_button_add_to_cart(cartItem) {
            cartService.add_to_cart(cartItem);
            messageStore.addMessage("Leistung hinzugefügt");
        }
        async function loadImage(product) {
            const image = product?.image;
            if (image) {
                const imageSrc = await fileService.getImageSrc(image);
                if (imageSrc && imageSrc.length > 0) {
                    imageUrl.value = imageSrc;
                }
            }
        }
        return (_ctx, _cache) => {
            const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs");
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_img = _resolveComponent("v-img");
            const _component_v_divider = _resolveComponent("v-divider");
            return (product.value !== null)
                ? (_openBlock(), _createBlock(_component_v_container, {
                    key: 0,
                    class: "d-flex flex-wrap v-col-12 pa-2"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_breadcrumbs, {
                            class: "d-flex v-col-12 justify-start pa-0",
                            divider: ">",
                            items: breadCrumbs.value
                        }, null, 8, ["items"]),
                        _createVNode(_component_v_container, { class: "v-col-xs-12 v-col-md-7 pa-0" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_container, {
                                    class: "text-h5 px-0 pb-0 text-center text-sm-start",
                                    "data-cy": "productTitle"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(product.value.title), 1)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_container, { class: "d-flex justify-start pa-0 text-subtitle-1" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(product.value.subtitle), 1)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_img, {
                                    "max-height": "400px",
                                    "max-width": "1000px",
                                    src: _unref(imageUrl),
                                    cover: ""
                                }, null, 8, ["src"]),
                                _createVNode(_component_v_container, { class: "text-start text-pre-line" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(product.value.description), 1)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_v_container, { class: "v-col-xs-12 v-col-md-5 pa-0 pb-2 pl-md-10" }, {
                            default: _withCtx(() => [
                                _createVNode(ProductMetaContainer, {
                                    product: product.value,
                                    onButtonClick: click_button_add_to_cart
                                }, {
                                    button: _withCtx(() => _cache[0] || (_cache[0] = [
                                        _createTextVNode("In den Warenkorb")
                                    ])),
                                    _: 1
                                }, 8, ["product"])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_v_divider),
                        (crossSellProducts.value.length > 0)
                            ? (_openBlock(), _createBlock(_component_v_container, {
                                key: 0,
                                class: "px-0"
                            }, {
                                default: _withCtx(() => [
                                    _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "d-flex justify-start" }, "Passend dazu", -1)),
                                    _createVNode(_component_v_container, { class: "d-flex flex-wrap pa-0" }, {
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(crossSellProducts.value, (crossSellProduct) => {
                                                return (_openBlock(), _createBlock(ProductPreviewComponent, {
                                                    key: crossSellProduct.id,
                                                    product: crossSellProduct
                                                }, null, 8, ["product"]));
                                            }), 128))
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
